import script from "./uesrManage.vue?vue&type=script&setup=true&lang=js"
export * from "./uesrManage.vue?vue&type=script&setup=true&lang=js"

import "./uesrManage.vue?vue&type=style&index=0&id=4c0570a1&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c0570a1"]])

export default __exports__